function roundDecimals(value: number): number {
    return Math.round((value + Number.EPSILON) * 100) / 100;
}

export default roundDecimals;
